import { useEffect } from 'react';
import { useAuth } from '../../components/features/auth/AuthGuard';
import PerformanceDashboard from '../../components/features/performance/PerformanceDashboard';
import { PERMISSIONS } from '../../constants';
import { Box, Alert, CircularProgress } from '@mui/material';

const PerformanceDashboardPage = () => {
  const { hasPermission } = useAuth();

  // Check if user has permission to view performance data
  if (!hasPermission(PERMISSIONS.PERFORMANCE_READ)) {
    return (
      <Box p={3}>
        <Alert severity="error">
          You don't have permission to view performance data.
        </Alert>
      </Box>
    );
  }

  return (
    <Box p={3}>
      <PerformanceDashboard />
    </Box>
  );
};

export default PerformanceDashboardPage;
